import { createApi } from "@reduxjs/toolkit/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString } from "../../utils/API/requestMiddleware"
import { defaultBaseQueryUserDetails } from '../../utils/API/fetchBaseQuery';

const userDetailsAPI = createApi({
    reducerPath: 'userDetailsAPI',
    baseQuery: defaultBaseQueryUserDetails,
    endpoints: (builder) => ({

        getUserDetailsByClientIdAndSecretkey: builder.query({
            query: () => ({
                url: encryptQueryString(`/Authentication/GetUserDetailsByClientIdAndSecretkey`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getUserdetailsListByClientIdAndClientSecret: builder.query({
            query: () => ({
                url: encryptQueryString(`https://centralizesystemtest.infixsofttech.com/api/User/GetUserdetailsListByClientIdAndClientSecret`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    }),
});

export const { useLazyGetUserDetailsByClientIdAndSecretkeyQuery, useLazyGetUserdetailsListByClientIdAndClientSecretQuery } = userDetailsAPI;

export default userDetailsAPI;